<template>
  <v-card
    :loading="loading"
    class="my-12"
    max-width="374"
    @click="_goDetail"
  >
    <template slot="progress">
      <v-progress-linear
        color="deep-purple"
        height="10"
        indeterminate
      ></v-progress-linear>
    </template>

    <v-img
      height="250"
      src="https://picsum.photos/361/267?random"
    ></v-img>

    <v-card-title>{{course.name}}</v-card-title>

    <v-card-text>
      <v-row align="center" class="mx-0">
     <v-rating
        :value="course.rating"
        background-color="white"
        color="yellow accent-4"
        dense
        half-increments
        hover
        size="18"
      />

        <div class="grey--text ml-4">4.5 {{(course.purchased)}}</div>
      </v-row>

      <div class="my-4 subtitle-1 text-left font-weight-bold text-h4" style="font-weight:bold">{{course.price | numericFormat}}₮</div>

      <div class="text-left" v-if="course.description">
       {{course.description.substring(0,50)}}...
      </div>
      <div v-else class="text-white">
       <br>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "CourseAnnouncement",
  props: {
    course: null,
  },
  data: () => ({
    loading: false,
    selection: 1,
  }),
  methods: {
    _goDetail() {
      this.$router.push({
        name: "PublicCourseDetail",
        params: { courseId: this.course.id },
      });
    },
  },
};
</script>